import { useState } from "react";
import { toast } from "sonner";

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

import { useAuth } from "@/contexts/AuthContext";
import { unlockAgent } from "@/services/agentAccess";

export default function AgentPasswordDialog({
  open,
  agent,
  onSuccess,
}) {
  const { token } = useAuth();

  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleUnlock = async () => {
    if (!password.trim()) {
      toast.error("Please enter the password.");
      return;
    }

    setLoading(true);

    try {
      await unlockAgent(token, agent, password);

      toast.success("Agent unlocked.");

      onSuccess();
    } catch (err) {
      toast.error(
        err.response?.data?.detail ||
          "Incorrect password."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      open={open}
      onOpenChange={() => {}}
    >
      <DialogContent
        onEscapeKeyDown={(e) => e.preventDefault()}
        onPointerDownOutside={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle>
            Protected Agent
          </DialogTitle>

          <DialogDescription>
            Enter the password to access this AI Agent.
          </DialogDescription>
        </DialogHeader>

        <Input
          type="password"
          placeholder="Password"
          value={password}
          autoFocus
          onChange={(e) => setPassword(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              handleUnlock();
            }
          }}
        />

        <Button
          disabled={loading}
          onClick={handleUnlock}
        >
          {loading ? "Unlocking..." : "Unlock"}
        </Button>
      </DialogContent>
    </Dialog>
  );
}